/**
 * Section header used between dashboard rows: small uppercase eyebrow chip
 * (accent-colour pill) followed by an h2 title.
 *
 * The eyebrow groups widgets into thematic sections (Overview, Operations,
 * Customer Feedback) and gives the page strong vertical rhythm.
 */
import { SectionTitleStyles } from "./sectionTitle.styles";

const SectionTitle = ({ eyebrow, title }) => (
  <SectionTitleStyles>
    {eyebrow && <span className="section-title__eyebrow">{eyebrow}</span>}
    <h2 className="section-title__heading">{title}</h2>
  </SectionTitleStyles>
);

export default SectionTitle;
